import actions from '../../actionTypes';

export default tags => {
  return {
    type: actions.SET_TAGS,
    tags
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/setTags.js